import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

// gemeinsam wachsen ähre

 ScrollTrigger.matchMedia({
    "(min-width: 1024px)": function() {

let aehreContainer = '.gemeinsam-wachsen__aehre'

// if (aehreContainer) {
  
  let aehreDescsDown = '.gemeinsam-wachsen__aehre__desc.js-line-down'
  let aehreDescsUp = '.gemeinsam-wachsen__aehre__desc.js-line-up'


  gsap.utils.toArray(aehreDescsDown).forEach((desc) => {
    let descHeadline = desc.querySelectorAll('.gemeinsam-wachsen__aehre__desc__headline')
    let descText = desc.querySelectorAll('.gemeinsam-wachsen__aehre__desc__text')
    let descTimeline = gsap.timeline({scrollTrigger:{trigger: desc}});

    descTimeline
    .from(descHeadline, 1, {y: -200, opacity: 0,})
    .from(descText, 1, {x: -200, opacity: 0,}, "-=.5");
  });

  gsap.utils.toArray(aehreDescsUp).forEach((desc) => {
    let descHeadline = desc.querySelectorAll('.gemeinsam-wachsen__aehre__desc__headline')
    let descText = desc.querySelectorAll('.gemeinsam-wachsen__aehre__desc__text')
    let descTimeline = gsap.timeline({scrollTrigger:{trigger: desc}});

    descTimeline
    .from(descHeadline, 1, {y: 200, opacity: 0, })
    .from(descText, 1, {x: 200, opacity: 0,}, "-=.5");

  });


// };

}});